import DateFormat from '@/shared/utils/date-format';
import RobotFilterType from './robot-filter-type.enum';
import { ContractGroupLinkedType } from './contract-group-linked-type.enum';
import { BillingDailyFilterType } from './billing-daily-filter-type.enum';
import { BillingAnniversaryFilterType } from './billing-anniversary-filter-type.enum';
import { ContractPeriodFilterType } from './contract-period-filter-type.enum';

export default class ContractFilter {
  contract: string;

  periodStart: string;

  periodEnd: string;

  anniversaryPeriodStart: string;

  anniversaryPeriodEnd: string;

  customerIds: Array<string>;

  customerDocument: string;

  status: string;

  selectedDates: Array<string>;

  expiresAtDates: Array<string>;

  expiresAtStart: string;

  expiresAtEnd: string;

  anniversarySelectedDates: Array<string>;

  billingAnniversaryType: BillingAnniversaryFilterType;

  selectedCustomerOption: string = 'name';

  selectedBeneficiaryOption: string = 'name';

  externalId: number;

  instanceCode: string;

  resultCenterId: string;

  isBillingEnabled: boolean;

  beneficiary: string;

  competenceFilter: string;

  markedToExpire: boolean;

  isCustomBilling: boolean;

  productIds: string;

  frequency: string;

  ruleGroupIds: Array<string>;

  isReviewed: boolean;

  filterInterval: ContractPeriodFilterType;

  robotFilterType: RobotFilterType;

  contractGroupId: string;

  contractGroupLinkedType: ContractGroupLinkedType;

  billingDaily: BillingDailyFilterType;

  contractModel: string;

  constructor(obj: any) {
    this.contract = obj.contract || '';
    this.periodStart = obj.periodStart || '';
    this.periodEnd = obj.periodEnd || '';
    this.anniversaryPeriodStart = obj.anniversaryPeriodStart || '';
    this.anniversaryPeriodEnd = obj.anniversaryPeriodEnd || '';
    this.customerIds = obj.customerIds || [];
    this.customerDocument = obj.customerDocument || '';
    this.status = obj.status || '';
    this.selectedDates = obj.selectedDates || [];
    this.expiresAtDates = obj.expiresAtDates || [];
    this.externalId = obj.externalId || '';
    this.instanceCode = obj.instanceCode || '';
    this.resultCenterId = obj.resultCenterId || '';
    this.isBillingEnabled = obj.isBillingEnabled || false;
    this.beneficiary = obj.beneficiary || '';
    this.competenceFilter = obj.competenceFilter || '';
    this.expiresAtStart = obj.expiresAtStart || '';
    this.expiresAtEnd = obj.expiresAtEnd || '';
    this.anniversarySelectedDates = obj.anniversarySelectedDates || [];
    this.billingAnniversaryType = obj.billingAnniversaryType || BillingAnniversaryFilterType.NONE;
    this.selectedCustomerOption = obj.selectedCustomerOption || 'name';
    this.selectedBeneficiaryOption = obj.selectedBeneficiaryOption || 'name';
    this.markedToExpire = obj.markedToExpire;
    this.isCustomBilling = obj.isCustomBilling;
    this.productIds = obj.productIds || '';
    this.frequency = obj.frequency || '';
    this.ruleGroupIds = obj.ruleGroupIds || [];
    this.isReviewed = obj.isReviewed;
    this.filterInterval = obj.filterInterval;
    this.robotFilterType = obj.robotFilterType || RobotFilterType.NONE;
    this.contractGroupId = obj.contractGroupId || null;
    this.contractGroupLinkedType = obj.contractGroupLinkedType || null;
    this.billingDaily = obj.billingDaily || BillingDailyFilterType.NONE;
    this.contractModel = obj.contractModel || '';
  }

  public static of(obj: any) {
    return new ContractFilter(obj || {})
  }

  prepareToSend() {
    this.setDates();
    this.removeDocumentMask();
  }

  private setDates(): void {
    if (this.selectedDates.length > 1) {
      this.selectedDates = this.selectedDates.map((el: string) => DateFormat.timestampToLocal(el))
      this.periodStart = this.selectedDates[0];
      this.periodEnd = this.selectedDates[1];
    }
    if (this.expiresAtDates.length > 1) {
      this.expiresAtDates = this.expiresAtDates.map((el: string) => DateFormat.timestampToLocal(el))
      this.expiresAtStart = this.expiresAtDates[0];
      this.expiresAtEnd = this.expiresAtDates[1];
    }
    if (this.anniversarySelectedDates.length > 1) {
      this.anniversarySelectedDates = this.anniversarySelectedDates
        .map((el: string) => DateFormat.timestampToLocal(el))
      this.anniversaryPeriodStart = this.anniversarySelectedDates[0];
      this.anniversaryPeriodEnd = this.anniversarySelectedDates[1];
    }
  }

  private removeDocumentMask() {
    this.customerDocument = this.customerDocument.replace('.', '');
    this.customerDocument = this.customerDocument.replace('.', '');
    this.customerDocument = this.customerDocument.replace('-', '');
    if (this.customerDocument.length > 14) {
      this.customerDocument = this.customerDocument.replace('/', '');
    }
  }

  get isTradingNameFetch(): boolean {
    return this.selectedCustomerOption === 'tradingName'
  }

  get isBeneficiaryTradingNameFetch(): boolean {
    return this.selectedBeneficiaryOption === 'tradingName'
  }
}
